import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Link from "@components/Link";
import {
  Card,
  CardActionArea,
  Grid,
  Box,
  Typography,
} from "@material-ui/core";
import Image from "next/image";
import Footer from "@components/Homepage/Footer";
import PublicPage from "@components/PublicPage";
import { useTranslation } from "react-i18next";
import DefaultMetadata from "@components/DefaultMetadata";

const useStyles = makeStyles((theme) => ({
  box: {
    alignContent: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "80vh",
  },
  root: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
    // height: "80vh",
    width: "100%",
    paddingTop: 50,
    paddingBottom: 50,
  },
  card: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    justifyContent: "center",
  },
  cover: {
    borderRadius: "3px",
    width: "100%",
    height: "300px",
    position: "relative",
  },
}));

// Instruction PDF Files. We assume that pdf and png preview files have exactly
// the same name but with different file extension
const files = [
  { name: "evloader_evb_en_manual", description: "Instructions - EV Box (EN)" },
  { name: "evloader_evb_el_manual", description: "Instructions - EV Box (EL)" },
  { name: "evloader_wallbox_en_manual", description: "Instructions - Wallbox (EN)" },
  { name: "evloader_wallbox_el_manual", description: "Instructions - Wallbox (EL)" }
]

function HelpCenter() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <PublicPage>
      <DefaultMetadata title="EV Loader | Help Center" />

      <Box className={classes.box} paddingX={10}>
        <Typography component="h1" variant="h2" color="primary">
          {t("Help Center")}
        </Typography>

        <div className={classes.root}>
          <Grid container spacing={3}>
            {files.map((file, index) => (
              <Grid item xs={12} sm={6} md={3} key={`pdf-file-${index}`}>
                <Link href={`/pdf/${file.name}.pdf`} naked>
                  <Card className={classes.card}>
                    <CardActionArea>
                      <div className={classes.cover}>
                        <Image
                          src={`/images/${file.name}.png`}
                          layout="fill"
                          title={file.description}
                          alt={file.description}
                          objectFit="cover"
                          quality="10"
                        />
                      </div>
                      <Typography
                        gutterBottom
                        variant="body1"
                        color="textSecondary"
                        style={{ marginLeft: "7px", marginTop: "10px" }}
                      >
                        {file.description}
                      </Typography>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
            ))}
          </Grid>
        </div>
      </Box>

      <Footer />
    </PublicPage>
  );
}

export default HelpCenter;
